import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import Menubar from '../home/menubar/Menubar';
import Header from '../home/header/Header';
import Address from '../home/footer/Address';
import { GrLogin } from "react-icons/gr";

function Login() {

    const Navigator = useNavigate();
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    const emailValidation = (event)=>{
    if(!/^[a-zA-Z0-9@._-]$/.test(event.key) && event.key.length === 1){
        event.preventDefault();
    }
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailRegex.test(email);

        const sendData = (e) => {
        e.preventDefault();

        if (!isEmailValid) {
            setEmailError(!isEmailValid);
            return;
        }
        
        if(email !== process.env.REACT_APP_USER_ID?.trim()){
            setEmailError(true);
            return;
        }

        
        if(password === '' || password !== process.env.REACT_APP_PASS){
            setNameError(true);
            return;
        }

        
        if(isEmailValid && email === process.env.REACT_APP_USER_ID && password === process.env.REACT_APP_PASS){
           Navigator('/quiz', {replace: true});
        }
     
        setNameError(false);
        setEmailError(false);

    }

  return (
    <div>
        <Header/>
        <Menubar/>
        <div className="#">
            <div className="col-md-5 mb-5 mt-5 p-3 rounded bg-light container login-form-container">
                <h3 className="form-label">Login <GrLogin/></h3>
                <form onSubmit={sendData} noValidate>
                        <div className="loginTitle">
                            <label htmlFor="validationemail" className="form-label" style={{width:'100%'}}>Email Id</label>
                            <div className="input-group has-validation">
                            <input
                                type="email"
                                placeholder='User Name'
                                className={`form-control ${emailError ? 'is-invalid' : ''}`}
                                style={{borderRadius: '30px'}}
                                id="validationemail"
                                aria-describedby="inputGroupPrepend"
                                autoComplete='off'
                                onKeyDown={emailValidation}
                                name="email"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); if (emailError) setEmailError(false); }}
                                required/>
                            <div className="invalid-feedback">Please provide a valid UserID!</div>
                            </div>
                        </div>
                        <div className="loginTitle">
                            <label htmlFor="validationName" className="form-label" style={{width:'100%'}}>Password</label>
                            <div className="input-group has-validation">
                                <input type="password" 
                                    name= 'password'
                                    id='validationName'
                                    value={password}
                                    placeholder='Password'
                                    maxLength={50}
                                    className={`form-control ${nameError ? 'is-invalid' : ''}`}
                                    style={{borderRadius: '30px'}}
                                    onChange={(e)=>{ setPassword(e.target.value); if (nameError) setNameError(false);}} 
                                    autoComplete='off'
                                    required/>
                            <div className="invalid-feedback">In Valid Password!</div>
                            </div>
                        </div>
                        <div className="quiz-btn">
                            <button className="btn btn-primary" type='submit' style={{borderRadius: '30px'}}>Login</button>
                        </div>
                </form>
            </div>
        </div>
        <Address/>
    </div>
  )
}

export default Login